import { Constant } from '@shared/constants/index'
import { THESIS_PAPER_STATUS } from '@/constants/index'

export const THESIS_TYPE = Object.freeze(
  new Constant({
    Manage: {
      label: '论文管理',
      value: 30001,
      name: 'ThesisAdviseManage',
    },
    Advisor: {
      label: '我指导的',
      value: 30002,
      name: 'ThesisAdviseMine',
    },
    Coach: {
      label: '我辅导的',
      value: 30003,
      name: 'ThesisCoachMine',
    },
    Review: {
      label: '我评审的',
      value: 30004,
      name: 'ThesisAdviseReview',
    },
  }),
)

export const ADVISOR_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Empty: THESIS_PAPER_STATUS.enums.Empty,
    ToAdvise: THESIS_PAPER_STATUS.enums.ToAdvise,
    Advising: THESIS_PAPER_STATUS.enums.Advising,
    AdvisorFailed: THESIS_PAPER_STATUS.enums.AdvisorFailed,
    AdvisorPassed: THESIS_PAPER_STATUS.enums.AdvisorPassed,
  }),
)

export const REVIEW_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Empty: THESIS_PAPER_STATUS.enums.Empty,
    ToReview: THESIS_PAPER_STATUS.enums.ToReview,
    Reviewing: THESIS_PAPER_STATUS.enums.Reviewing,
    ReviewFailed: THESIS_PAPER_STATUS.enums.ReviewFailed,
    ReviewPassed: THESIS_PAPER_STATUS.enums.ReviewPassed,
  }),
)

export const COACH_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Empty: THESIS_PAPER_STATUS.enums.Empty,
    Coaching: THESIS_PAPER_STATUS.enums.Coaching,
    CoachComplete: THESIS_PAPER_STATUS.enums.CoachComplete,
  }),
)

export const AI_ADVISOR_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Advised: { label: '已生成', value: 3 },
    UnAdvise: { label: '未生成', value: 1 },
    Advising: { label: '生成中', value: 2 },
  }),
)

export const AI_REFINEMENT_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Refined: { label: '已生成', value: 1 },
    UnRefine: { label: '未生成', value: 2 },
    Refining: { label: '生成中', value: 3 },
    NoNeedRefine: { label: '无需生成', value: 4 },
  }),
)

export const REVIEW_RESULT = Object.freeze(
  new Constant({
    ReviewPassed: THESIS_PAPER_STATUS.enums.ReviewPassed,
    ReviewFailed: { label: '不通过', value: THESIS_PAPER_STATUS.enums.ReviewFailed.value },
  }),
)

export const REVIEW_ACTION = Object.freeze({
  Save: 1,
  Submit: 2,
})

export const CHECK_STRUCTURE_STATUS = Object.freeze(
  new Constant({
    All: THESIS_PAPER_STATUS.enums.All,
    Empty: THESIS_PAPER_STATUS.enums.Empty,
    CHECKING: { label: '检测中', value: 1 },
    CHECK_FAIL: { label: '未通过', value: 2 },
    CHECK_SUCCESS: { label: '通过', value: 3 },
  }),
)
export const PAPER_VERSION = Object.freeze(
  new Constant({
    Latest: { label: '最新稿', value: 1 },
    All: { label: '所有稿', value: 2 },
  }),
)

export const PAPER_DOWNLOAD_RANGE = Object.freeze(
  new Constant({
    Paper: { label: '论文', value: 1, mineAdviseLabel: '论文原稿' },
    PlagiarismReport: { label: '查重报告', value: 2, mineAdviseLabel: '' },
    Advise: { label: '指导意见', value: 3, mineAdviseLabel: '带指导意见的论文' },
    AiScoreReport: { label: 'AI评分报告', value: 4, mineAdviseLabel: 'AI评分报告' },
    Coach: { label: '辅导结果', value: 5, mineAdviseLabel: '' },
    ScoreReport: { label: '评审老师评分报告', value: 6, mineAdviseLabel: '指导老师评分报告' },
    ExamplePaper: { label: '参考示例', value: 7, mineAdviseLabel: '参考示例' },
  }),
)

